import mapbox from 'mapbox-gl';

mapbox.accessToken = "pk.eyJ1Ijoic2FtbGVhcm5lciIsImEiOiJja29yYWZ3bHcweGVxMm5zMWZodGhzOG9kIn0.Xx56P5o8mK08nrvMCsmV_w";

export { mapbox };